$('.js-scroll-to').on('click', function(event) {
	event.preventDefault();
	const link = $(this).attr('href');

	$('html, body').animate({
		scrollTop: $(link).offset().top - $('.header').outerHeight()
	}, 600);
});
